/* unplugin-vue-components disabled */import script from "./Product.vue?vue&type=script&setup=true&lang=ts"
export * from "./Product.vue?vue&type=script&setup=true&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=4dd36b08&scoped=true&lang=less"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd36b08"]])

export default __exports__